import React from 'react';

const Select = ({ name, data, onChange, value }) => {
  return (
    <div className='container_select'>
      <div>
        <label className="textPrimaryLabelInput">{name}</label>
        <select onChange={onChange} value={value}>
          <option value="" style={{ fontFamily: "sans-serif" }}>
            Selecione
          </option>
          {data
            ?.filter(item => item.instalation !== value)
            .map(item => (
              <option key={item.name} value={item.name} style={{ fontFamily: "sans-serif" }}>
                {item.name}
              </option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default Select;
